import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}


export const navigation = {
  pages: [
    { name: "Mobile", href: "#", imageSrc: "https://files.svgcdn.io/uiw/mobile.svg", imageAlt: "icon" },
    { name: "Home Needs", href: "#", imageSrc: "https://files.svgcdn.io/material-symbols/grocery.svg", imageAlt: "icon" },
    { name: "Beauty", href: "#", imageSrc: "https://files.svgcdn.io/solar/airbuds-broken.svg", imageAlt: "icon" },
    { name: "Furniture", href: "#", imageSrc: "https://files.svgcdn.io/icon-park/clothes-crew-neck.svg", imageAlt: "icon" }
  ],
  categories: [
    {
      id: "men",
      name: "Men",
      image: "https://rukminim2.flixcart.com/fk-p-flap/98/98/image/8703c2a8db2b01a4.jpg?q=80",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/2616c76f5621cf29.jpg?q=80",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/504ea2badfb22ff2.jpg?q=80",
          imageAlt:
            "Three shirts in gray, white, and indigo arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "clothing",
          name: "Clothing",
          items: [
            { name: "Tops", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
          ],
        },
      ],
    },
    {
      id: "women",
      name: "Women",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/1a36518dc0ae569f.jpg?q=80",
          imageAlt:
            "Models sitting back to back, wearing Basic Tee in black and bone.",
        },
        {
          name: "Basic Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/21990eb66beeeda7.jpg?q=100",
          imageAlt:
            "Close up of Basic Tee fall bundle with off-white, ochre, olive, and black tees.",
        },
      ],
      sections: [
        {
          id: "clothing",
          name: "Clothing",
          items: [
            { name: "Tops", href: "#" },
            { name: "Dresses", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Denim", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Significant Other", href: "#" },
          ],
        },
      ],
    },
    {
      id: "electronics",
      name: "Electronics",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/f08e1772ddd4839c.png?q=100",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/380/380/image/9379892d6deefcc3.jpg?q=100",
          imageAlt:
            "Three shirts in gray, white, and indigo arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "Laptop",
          name: "Laptop",
          items: [
            { name: "Tops", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
          ],
        },
      ],
    },
    {
      id: "grocery",
      name: "Grocery",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/300/400/image/025bb0a526e76a50.jpg?q=100",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/fk-p-flap/300/400/image/651c56503b2afe6d.jpg?q=100",
          imageAlt:
            "Three shirts in gray, white, and indigo arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "Home Essentials",
          name: "Home Essential",
          items: [
            { name: "Tops", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
          ],
        },
      ],
    },
    {
      id: "books",
      name: "Books",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/image/612/612/xif0q/book/a/a/m/pw-nta-15-neet-rankers-test-series-2026-verified-curated-by-original-imahgdvggkqygmtp.jpeg?q=100",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/image/1366/1366/xif0q/regionalbooks/f/h/a/talent-academy-degree-level-prelims-mains-rank-file-2025-2026-original-imahhp7ugrwpgndj.jpeg?q=100",
          imageAlt:
            "Three shirts in gray, white, and indigo arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "Laptop",
          name: "Laptop",
          items: [
            { name: "Tops", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
          ],
        },
      ],
    },
    {
      id: "appliances",
      name: "Appliances",
      featured: [
        {
          name: "New Arrivals",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/image/1366/1366/xif0q/television/i/l/y/24hdndqeetb-marq-by-flipkart-original-imah6fcezkqwzae8.jpeg?q=90",
          imageAlt:
            "Drawstring top with elastic loop closure and textured interior padding.",
        },
        {
          name: "Artwork Tees",
          href: "#",
          imageSrc:
            "https://rukminim2.flixcart.com/image/1366/1366/xif0q/air-fryer/x/y/z/black-4-5-1400-ultra-digital-air-fryer-4-5l-digital-display-original-imahh6dhuetzavwg.jpeg?q=90",
          imageAlt:
            "Three shirts in gray, white, and indigo arranged on table with same line drawing of hands and shapes overlapping on front of shirt.",
        },
      ],
      sections: [
        {
          id: "Home Essentials",
          name: "Home Essential",
          items: [
            { name: "Tops", href: "#" },
            { name: "Pants", href: "#" },
            { name: "Sweaters", href: "#" },
            { name: "T-Shirts", href: "#" },
            { name: "Jackets", href: "#" },
            { name: "Activewear", href: "#" },
            { name: "Browse All", href: "#" },
          ],
        },
        {
          id: "accessories",
          name: "Accessories",
          items: [
            { name: "Watches", href: "#" },
            { name: "Wallets", href: "#" },
            { name: "Bags", href: "#" },
            { name: "Sunglasses", href: "#" },
            { name: "Hats", href: "#" },
            { name: "Belts", href: "#" },
          ],
        },
        {
          id: "brands",
          name: "Brands",
          items: [
            { name: "Re-Arranged", href: "#" },
            { name: "Counterfeit", href: "#" },
            { name: "Full Nelson", href: "#" },
            { name: "My Way", href: "#" },
          ],
        },
      ],
    },

  ],
};


export default function ProductCategoryNavbar() {

  return (
    <div className="bg-white">
      {/* Product Navbar */}
      <header className="relative productNavbar">
        <nav className="flex mx-auto w-full px-4 sm:px-6 lg:px-8 overflow-hidden flex-nowrap !z-50">

          {/* product categories start section 2 */}
          <div className="flex justify-around basis-full my-2">
            <Popover.Group className="lg:block lg:self-stretch justify-around">
              <div className="grid justify-around hide_remainingRows sm:grid-cols-3 md:grid-cols-6 overflow-hidden grid-cols-3 gap-2 lg:grid-cols-10 h-full">
                {navigation.categories.map((category) => (
                  <Popover key={category.name} className="grid ">
                    {({ open }) => (
                      <>
                        <div className="flex justify-around align-middle flex-col">
                          <div className="relative flex justify-around px-2 pt-4">
                            <img src="https://rukminim2.flixcart.com/fk-p-flap/98/98/image/f03c562321e764bb.jpg?q=100" alt="29327f40e9c4d26b" border="0"></img>
                          </div>
                          <div className="relative  px-2 flex justify-around">
                            <div className="flex items-center justify-around">
                              <Popover.Button className={classNames(
                                open
                                  ? "border-indigo-600 text-indigo-600 "
                                  : "border-transparent text-gray-700 hover:text-gray-800",
                                "relative z-10  outline-none -mb-px flex items-baseline border-b-2 pt-2 text-[15px] font-medium transition-colors duration-200 ease-out"
                              )}
                              >
                                {category.name}{" "}
                                <svg className={`w-2 h-2  ml-1.5 transition duration-150 ease-in-out ${open ? "rotate-180 " : "rotate-0	"}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                                </svg>
                              </Popover.Button>
                            </div>
                          </div>
                        </div>
                        <Transition as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0" enterTo="opacity-100" leave="transition ease-in duration-150" leaveFrom="opacity-100" leaveTo="opacity-0" >
                          <Popover.Panel className="absolute inset-x-0 top-full text-sm text-gray-500 z-20">
                            <div className="absolute inset-0 top-1/2 bg-white shadow-2xl" aria-hidden="true" />
                            <div className="relative bg-white">
                              <div className="mx-auto max-w-6xl px-8">
                                <div className="grid grid-cols-1 md:grid-cols-2  gap-x-8 gap-y-10 py-8">
                                  <div className="col-start-2  grid-cols-2 gap-x-8 hidden md:grid">
                                    {category.featured.map((item) => (
                                      <div key={item.name} className="group relative text-base sm:text-sm">
                                        <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                          <img src={item.imageSrc} alt={item.imageAlt} className="object-cover object-center z-30" />
                                        </div>
                                        <a href={item.href} className="mt-6 block font-medium text-gray-900">
                                          <span className="absolute inset-0 z-10" aria-hidden="true" />
                                          {item.name}
                                        </a>
                                        <p aria-hidden="true" className="mt-1">Shop now</p>
                                      </div>
                                    ))}
                                  </div>
                                  {/* End of imageSection */}
                                  <div className="row-start-1 grid grid-cols-3 gap-x-8 gap-y-10 text-sm">
                                    {category.sections.map((section) => (
                                      <div key={section.name}>
                                        <p id={`${section.name}-heading`} className="font-medium text-gray-900">
                                          {section.name}
                                        </p>
                                        <ul aria-labelledby={`${section.name}-heading`} className="mt-6 space-y-6 sm:mt-4 sm:space-y-4">
                                          {section.items.map((item) => (
                                            <li key={item.name} className="flex">
                                              <a href={item.href} className="hover:text-gray-800">
                                                {item.name}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Popover.Panel>
                        </Transition>
                      </>
                    )}
                  </Popover>
                ))}
                {navigation.pages.map((page) => (
                  <div key={page.name} className="grid">
                    <div className="flex justify-center align-middle flex-col">
                      <div className="relative flex justify-center px-2 pt-4">
                        <img src="https://rukminim2.flixcart.com/fk-p-flap/98/98/image/f03c562321e764bb.jpg?q=100" alt="29327f40e9c4d26b" border="0"></img>
                      </div>
                      <div className="relative justify-center flex">
                        <a key={page.name} href={page.href} className="flex items-center text-[15px] pt-2 font-medium text-gray-700 hover:text-gray-800">
                          {page.name}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Popover.Group>
          </div>
        </nav>
      </header>
    </div>
  );
}

